import { render } from "./MainHeader.html?vue&type=template&id=1d4e078a&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=ts"
export * from "./MainHeader.vue?vue&type=script&lang=ts"

import "./MainHeader.css?vue&type=style&index=0&id=1d4e078a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1d4e078a"

export default script